import { Card, Text } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  width: 380px;
  position: relative;

  &.disabled {
    opacity: 0.65;
    filter: grayscale(100%);
  }
`;

export const StyledCard = styled(Card)<{ highlight?: boolean }>`
  width: 100%;
  max-width: 320px;
  padding: 24px;
  border-radius: 12px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  box-shadow: ${({ highlight }) =>
    highlight ? '0px 8px 20px rgba(0, 0, 255, 0.2)' : '0px 4px 12px rgba(0, 0, 0, 0.1)'};
  border: ${({ highlight }) =>
    highlight ? '2px solid var(--mantine-color-blue-6)' : '1px solid var(--mantine-color-gray-3)'};
  transform: ${({ highlight }) => (highlight ? 'scale(1.07)' : 'none')};
  &:hover {
    transform: scale(1.08);
    box-shadow: 0px 10px 24px rgba(0, 0, 255, 0.25);
  }
`;

export const FeatureText = styled(Text)`
  font-size: 15px;
  color: var(--mantine-color-gray-4);
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 18px;
  }

  &.faded {
    opacity: 0.5;
  }
`;

export const PlanTitle = styled(Text)`
  text-align: center;
  font-weight: 600;
`;

export const PlanDescription = styled(Text)`
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  opacity: 0.5;
`;

export const FeaturesPrefix = styled(Text)`
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  text-align: center;
  margin-top: 10px;
`;

export const PriceText = styled(Text)`
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  margin-top: 8px;
`;

export const PreviousPriceText = styled(Text)`
  font-size: 21px;
  text-decoration: line-through;
  font-weight: 500;
  text-align: center;
  position: relative;
  top: 10px;
`;

export const FeatureList = styled.div``;

export const ActionGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const ContactUs = styled(PriceText)``;

export const BadgeContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export const Category = styled.div``;

export const CategoryHeader = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin: 3px 0;
  text-align: center;
  margin-top: 16px;
`;

export const CategoryFeatures = styled.div``;
